.content {
  display: grid;
  gap: 1.5rem;
}

.card {
  padding: 1.5rem 1rem;
  background-color: var(--brand-light);
  border: 1px var(--brand-grayscale-200) solid;
  border-radius: 5px;
}
